import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";
import { mutatorAction } from "satcheljs";
import schedulesViewStateStore from "../store/store";

/**
 * The mutatorAction to set conflict progress state
 * @param inProgress - boolean - the inProgress state of calculation
 */
export default mutatorAction('SET_IS_CONFLICT_CALCULATION_IN_PROGRESS', function setIsConflictCalculationInProgress(
    inProgress: boolean,
    viewState?: SchedulesViewStateStore | IPreviewSchedulePageStore
) {
    (viewState ? viewState : schedulesViewStateStore()).isConflictCalculationInProgress = inProgress;
});